import { render } from "./HomeExamPaper.vue?vue&type=template&id=b93e83ec&scoped=true"
import script from "./HomeExamPaper.vue?vue&type=script&lang=js"
export * from "./HomeExamPaper.vue?vue&type=script&lang=js"

import "./HomeExamPaper.vue?vue&type=style&index=0&id=b93e83ec&lang=less&scoped=true"

import exportComponent from "E:\\edu-ui\\JzEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b93e83ec"]])

export default __exports__